import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import CompWrapper from "../../hoc/compWrapper/CompWrapper.hoc";
import Title from "../../common/title/Title.common";
import { StationChief } from "../components";

// ACTIONs
import { useDispatch, useSelector } from "react-redux";
import { getStationChiefAction } from "../../../actions/Actions";

const Chiefs = [
  {
    name: "Dr. govinda timsina",
    remarks: null,
    from: "2/3/2021",
    to: "2/3/2025",
  },
  {
    name: "Dr. govinda timsina",
    remarks: null,
    from: "2/3/2021",
    to: "2/3/2025",
  },
  {
    name: "Dr. govinda timsina",
    remarks: null,
    from: "2/3/2021",
    to: "2/3/2025",
  },
  {
    name: "Dr. govinda timsina",
    remarks: null,
    from: "2/3/2021",
    to: "2/3/2025",
  },
  {
    name: "Dr. govinda timsina",
    remarks: null,
    from: "2/3/2021",
    to: "2/3/2025",
  },
  {
    name: "Dr. govinda timsina",
    remarks: null,
    from: "2/3/2021",
    to: "2/3/2025",
  },
];

export const ListofStationChief = () => {
  const { setHeaderTitle } = useAuth();
  const dispatch = useDispatch();
  const { stationChiefLoader, stationChiefList } = useSelector(
    (state) => state.teamMember,
  );

  useEffect(() => {
    dispatch(getStationChiefAction());
  }, [getStationChiefAction]);

  useEffect(() => {
    setHeaderTitle("List of Station Chief");
  }, [setHeaderTitle]);
  return (
    <CompWrapper>
      <Title title="List of Station Chief" hide_SeeAll />

      <StationChief chiefs={stationChiefList} />
    </CompWrapper>
  );
};
